// 이메일 유효성 검사
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) return '이메일을 입력해주세요.';
  if (!emailRegex.test(email)) return '올바른 이메일 형식이 아닙니다.';
  return '';
};

// 비밀번호 강도 검사
export const validatePassword = (password) => {
  if (!password) return '비밀번호를 입력해주세요.';
  if (password.length < 8) return '비밀번호는 8자 이상이어야 합니다.';
  if (!/(?=.*[a-z])/.test(password)) return '소문자를 포함해야 합니다.';
  if (!/(?=.*[A-Z])/.test(password)) return '대문자를 포함해야 합니다.';
  if (!/(?=.*\d)/.test(password)) return '숫자를 포함해야 합니다.';
  if (!/(?=.*[@$!%*?&])/.test(password)) return '특수문자(@$!%*?&)를 포함해야 합니다.';
  return '';
};

// 닉네임 유효성 검사
export const validateNickname = (nickname) => {
  if (!nickname) return '닉네임을 입력해주세요.';
  if (nickname.length < 2) return '닉네임은 2자 이상이어야 합니다.';
  if (nickname.length > 20) return '닉네임은 20자 이하여야 합니다.';
  if (!/^[가-힣a-zA-Z0-9_]+$/.test(nickname)) return '닉네임은 한글, 영문, 숫자, 언더스코어만 사용 가능합니다.';
  return '';
};

// 비밀번호 강도 점수 계산
export const getPasswordStrength = (password) => {
  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  if (/(?=.*[a-z])/.test(password)) score += 1;
  if (/(?=.*[A-Z])/.test(password)) score += 1;
  if (/(?=.*\d)/.test(password)) score += 1;
  if (/(?=.*[@$!%*?&])/.test(password)) score += 1;
  
  if (score <= 2) return { level: 'weak', text: '약함', color: '#e74c3c' };
  if (score <= 4) return { level: 'medium', text: '보통', color: '#f39c12' };
  return { level: 'strong', text: '강함', color: '#27ae60' };
};